import { Capacitor } from '@capacitor/core';

/**
 * Gets the base URL for the application based on the current environment and platform
 */
export const getBaseUrl = (): string => {
  const productionUrl = 'https://rabbiwechter.com'; // Replace with your production URL
  
  // Use environment variable if available
  if (import.meta.env.VITE_PUBLIC_URL) {
    return import.meta.env.VITE_PUBLIC_URL;
  }

  // For native platforms
  if (Capacitor.isNativePlatform()) {
    // Always use production URL for sharing on native platforms, even in development
    return productionUrl;
  }

  // For web
  const currentOrigin = window.location.origin;
  if (currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1')) {
    return productionUrl;
  }

  return currentOrigin;
};

/**
 * Generates a shareable URL for the current page
 * @param path - The path portion of the URL (without the domain)
 */
export const getShareableUrl = (path: string): string => {
  const baseUrl = getBaseUrl();
  // Extract the path portion from the current URL if no path is provided
  const urlPath = path || window.location.pathname + window.location.search;
  const cleanPath = urlPath.startsWith('/') ? urlPath : `/${urlPath}`;
  return `${baseUrl}${cleanPath}`;
}; 